import { Link, useLocation } from "react-router-dom";
import { useAuth } from "../state/AuthContext";

/**
 * G-136 — until a person confirms their sign-in address, "Forgot password?"
 * cannot help them (it sends only to a confirmed address). One line at the
 * top of every page says so and points at Profile, where one tap sends the
 * link. It goes away by itself once the address is confirmed.
 *
 * G-145 (OD-224): not on Profile itself — the profile header carries the
 * badge and the Confirm my email button there, so the nudge appears once.
 */
export function EmailConfirmBanner() {
  const { user } = useAuth();
  const { pathname } = useLocation();
  if (!user || user.emailVerified !== false) return null;
  if (pathname === "/app/profile" || pathname.startsWith("/app/profile/")) return null;
  return (
    <div className="alert warning email-confirm-banner">
      <span>
        Confirm your email address so you can reset your password yourself if you ever forget it.{" "}
        <Link className="alert-link" to="/app/profile">
          Confirm it on Profile
        </Link>
      </span>
    </div>
  );
}
